import {useContext, useState} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {FiMic as UnmutedIcon, FiMicOff as MutedIcon} from 'react-icons/fi';
import {IoCallOutline as CallIcon} from 'react-icons/io5';
import Button from './ButtonCmp';
import {WSState} from '../providers/WebSocketProvider';

const ActionCmp = ({userId, inCall}) => {
  const [showButton, setShowButton] = useState(inCall ? false : true);
  const {dispatch: wsDispatch} = useContext(WSState);

  const handleInvite = (connectionId) => {
    wsDispatch({
      type: 'send-invitation', 
      connectionId: connectionId,
    });

    setShowButton(false);
  };
  
  return showButton ? (
    <Button color="green" handleClick={() => handleInvite(userId)}><CallIcon /></Button>
  ) : (
    <div></div>
  );
};

ActionCmp.propTypes = {
  userId: PropTypes.string.isRequired,
  inCall: PropTypes.bool.isRequired,
};

const List = styled.ul`
  overflow-y: auto;
  height: 100%;
`;

const Item = styled.li`
  background-color: ${({ theme }) => theme.background.overlay};
  border-radius: 50px !important;
  margin: .25rem 0;
  padding: .5rem;
  display: flex;
  justify-content: space-between;
`;

const UserListCmp = ({users}) => {
  const {state: wsState} = useContext(WSState);

  const isHost = wsState && wsState.isHost ? wsState.isHost : null;
  const connectionId = wsState && wsState.connectionId ? wsState.connectionId : null;

  return (
    <List isHost={isHost}>
      {users.map(user => (
        <Item key={user.connectionId}>
          {user.name}

          {isHost && (
            <>
              {user.connectionId !== connectionId && (
                <>
                  <ActionCmp 
                    userId={user.connectionId} 
                    inCall={user.inCall} 
                  />

                  {user.inCall && (
                    user.isMuted ? <MutedIcon /> : <UnmutedIcon />
                  )}
                </>
              )}
            </>
          )}
        </Item>
      ))}
    </List>
  );
};

UserListCmp.propTypes = {
  users: PropTypes.array,
};

export default UserListCmp;
